import React, { type FC, Fragment } from 'react'
import { Button, type ButtonProps, Grid } from '@mui/material'

import { IconButton, LogsIcon } from '../common'

const variants = [
    'primary',
    'secondary',
    'primaryOutline',
    'primaryGhost',
    'ghost',
    'danger',
    'dangerOutline',
    'dangerGhost',
    'legacyAmber',
] as const satisfies readonly ButtonProps['variant'][]

const sizes = ['small', 'medium', 'large'] as const satisfies readonly ButtonProps['size'][]

export const Buttons: FC = () => {
    return (
        <>
            {variants.map((variant) => (
                <Fragment key={variant}>
                    {/* All Variants */}
                    <Grid container spacing={2} sx={{ my: 6 }}>
                        <Grid size={6}>
                            {sizes.map((size) => (
                                <Button key={size} variant={variant} size={size} sx={{ mr: 4 }}>
                                    Button
                                </Button>
                            ))}
                        </Grid>
                        <Grid size={6}>
                            {sizes.map((size) => (
                                <IconButton key={size} variant={variant} size={size} sx={{ mr: 4 }}>
                                    <LogsIcon />
                                </IconButton>
                            ))}
                        </Grid>
                    </Grid>

                    {/* Disabled state for each variant */}
                    <Grid container spacing={2} sx={{ my: 6 }}>
                        <Grid size={6}>
                            {sizes.map((size) => (
                                <Button key={size} disabled variant={variant} size={size} sx={{ mr: 4 }}>
                                    Button
                                </Button>
                            ))}
                        </Grid>
                        <Grid size={6}>
                            {sizes.map((size) => (
                                <IconButton key={size} disabled variant={variant} size={size} sx={{ mr: 4 }}>
                                    <LogsIcon />
                                </IconButton>
                            ))}
                        </Grid>
                    </Grid>
                </Fragment>
            ))}
        </>
    )
}
